module.exports = __webpack_public_path__ + "img/rank_5.5cc7550.png";